// extracted by mini-css-extract-plugin
export var checkbox = "_2c-0";
export var circle = "_2c-3";
export var horizontalContainer = "_2c-7";
export var sm = "_2c-5";
export var switch0 = "_2c-2";
export var switchDisabled = "_2c-8";
export var switchEnabled = "_2c-1";
export var textSwitchContainer = "_2c-9";
export var textSwitchOption = "_2c-a";
export var textSwitchOptionSelected = "_2c-b";
export var verticalContainer = "_2c-6";
export var xs = "_2c-4";